import * as React from 'react'

import { observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import Localization from '../../localization/LocalizationManager'
import { Button } from '../Button/Button'
import { AddIcon } from '../icons/AddIcon'

interface IProps {
  openFormTypeSelectionForm?: () => void
  className?: string
}

@observer
export default class LogisticsCreationListMenu extends React.Component<IProps> {
  public render() {
    const { className } = this.props
    return (
      <div className={classList({ 'tw:flex': true, [className]: !!className })}>
        {this.renderCreateNewButton()}
      </div>
    )
  }

  private renderCreateNewButton(): JSX.Element {
    return (
      <Button
        variant="default"
        size="lg"
        onClick={this.openFormTypeSelector}
        data-testid="workflows-create-new-button"
      >
        <AddIcon data-icon="inline-start" size="sm" />
        {Localization.translator.createNew}
      </Button>
    )
  }

  private openFormTypeSelector = () => {
    this.props.openFormTypeSelectionForm?.()
  }
}
